export const AI_MODELS = [
  {
    id: 'gpt-4o-2024-08-06',
    name: 'GPT-4o',
    displayName: 'GPT-4o'
  },
  {
    id: 'gpt-4o-mini-2024-07-18',
    name: 'GPT-4o Mini',
    displayName: 'GPT-4o Mini'
  },
  {
    id: 'o1-mini-2024-09-12',
    name: 'O1 Mini',
    displayName: 'O1 Mini'
  },
  {
    id: 'claude-3-5-haiku-20241022',
    name: 'Claude 3.5 Haiku',
    displayName: 'Claude 3.5 Haiku'
  },
  {
    id: 'claude-3-5-sonnet-20241022',
    name: 'Claude 3.5 Sonnet',
    displayName: 'Claude 3.5 Sonnet'
  },
  {
    id: 'deepseek-chat',
    name: 'DeepSeek-V3',
    displayName: 'DeepSeek-V3'
  },
  {
    id: 'deepseek-reasoner',
    name: 'DeepSeek-R1',
    displayName: 'DeepSeek-R1'
  },
]; 